var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"INFOCAFE","src":require("../assets/logo.png"),"width":"20%"}})])
}]

export { render, staticRenderFns }